import {Component, HostBinding, Input} from '@angular/core';

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
})
export class AppCardComponent {
    @HostBinding('class')
    className: string = 'card';

    @Input()
    hasSideLine: boolean = false;
}
